/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum WoundsDressingsTabListAliases {
  CONTEXTUAL_BAR = 'contextual-bar',
  FRAGMENT_REFERENCE_DRESSINGS = 'fragment-reference-dressings',
  FRAGMENT_REFERENCE_WOUNDS = 'fragment-reference-wounds',
  FRAGMENT_REFERENCE_WOUNDS_IMAGES = 'fragment-reference-wounds-images',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  LAYOUT_WOUNDS_DRESSINGS_TAB_LIST = 'layout-wounds-dressings-tab-list',
  PANEL_TAB_CONTROL = 'panel-tab-control',
  SUPPRESS_HEADING_MARGIN_0 = 'suppress-heading-margin-0',
  TAB_CONTROL = 'tab-control',
  TAB_WITH_CONTENT_DRESSINGS = 'tab-with-content-dressings',
  TAB_WITH_CONTENT_WOUNDS = 'tab-with-content-wounds',
  TAB_WITH_CONTENT_WOUNDS_IMAGES = 'tab-with-content-wounds-images',
}
export { WoundsDressingsTabListAliases };
